import { Box, Button, Text } from "@mbank-design/design-system/components";
import { FontColor } from "@mbank-design/design-system/design-tokens/general/typography";
import { Link } from "react-router-dom";
import CarsCarousel from "../../parts/CarsCarousel";
import { useEffect, useRef, useState } from "react";
import { getNewVehicles } from "../../../services";
import { useMobileOnlyMedia } from "@mbank-design/design-system/components/Media/useMobileOnlyMedia";
import { CARS_PER_PAGE, CARS_PER_PAGE_MOBILE } from "../../../constants";
import { imitationClickForCloseAllTooltips } from "../../../scripts/commons/common";
import "./index.scss";
/**
 * @deprecated
 * This is old version of the component.
 * It is kept for the backward compatibility.
 * It is not used in the new version of the website.
 */
export const NoCarsSearch = () => {
  const [carouselCars, setCarouselCars] = useState([]);
  const [carouselCarsPage, setCarouselCarsPage] = useState(1);

  const isMobile = useMobileOnlyMedia();


  useEffect(() => {
    getNewVehiclesFromApi();
  }, []);

  const getNewVehiclesFromApi = () => {
    getNewVehicles({ ResultsPerPage: isMobile ? CARS_PER_PAGE_MOBILE : CARS_PER_PAGE, Page: carouselCarsPage }).then(
      (response) => {
        let newCarsData = response.data.Tails
        setCarouselCars(newCarsData);
      }
    );
  };

  const onNewVehiclesCarouselPageChange = () => {
    imitationClickForCloseAllTooltips();
  };

  return (
    <div className="no-cars-set-alert-section">
      <Text
        as="h2"
        styledAs={"h1_large"}
      >
        nie znalazłeś auta na mAuto?
      </Text>
      <Text as={"body"}>skontaktuj się z nami, a my znajdziemy dla Ciebie wymarzony samochód!</Text>
      <Box paddingBottom={[12,52]}><Link to={"/formularz-kontaktowy"}><Button>zapytaj o ofertę</Button></Link></Box>
      <Box width={"100%"}>
          <CarsCarousel
            carsType={"recommended"}
            carsCount={carouselCars.length}
            carsList={carouselCars}
            changeHandler={() => onNewVehiclesCarouselPageChange()}
            buttonText={"zobacz wszystkie auta"}
            buttonLink={"/lista-pojazdow?&isCompany=true&financialMethod=all&selectedSortingValue=0"}
            sectionTitle={"samochody, które mogą Cię zainteresować"}
            sectionDescription={"dostępne od ręki z dostawą pod dom"}
            theme="white"
            additionalAsset
          />
      </Box>
    </div>
  );
};
